import ReactDOM from "react-dom/client";
import React, { useState } from "react";
import { BrowserRouter } from "react-router-dom"; // Import BrowserRouter
import { ThemeContextProvider } from "./contexts/ThemeContext.jsx";
import App from "./App.jsx";
import "normalize.css";
import "./index.css";

function Main() {
  const [mode, setMode] = useState("light");

  return (
    <ThemeContextProvider>
      <BrowserRouter>
        {" "}
        {/* Wrap the application in BrowserRouter */}
        <App />
      </BrowserRouter>
    </ThemeContextProvider>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(<Main />);
